<template>
  <div class="app">
    <AppHeader fixed>
      <b-link class="navbar-brand" to="/">
        <img
          class="navbar-brand-full d-md-down-none"
          src="@/../public/img/brand/entirelogo.svg"
          width="89"
          height="25"
          alt="Carlbot logo"
        />
        <img
          class="navbar-brand-minimized"
          src="@/../public/img/brand/googleturtle.svg"
          width="30"
          height="30"
          alt="Carlbot logo"
        />
      </b-link>
      <b-navbar-nav class="d-md-down-none nav-title">
        <b-nav-item class="px-2" href="https://docs.carl.gg/">
          <i class="fas fa-book mr-1"></i>Docs
        </b-nav-item>
        <b-nav-item
          class="px-2"
          href="https://discord.com/oauth2/authorize?&client_id=235148962103951360&scope=applications.commands+bot&permissions=2088234230&response_type=code&redirect_uri=https://carl.gg/api/server_auth"
          exact
        >
          <i class="fas fa-plus mr-1"></i>Invite
        </b-nav-item>
        <b-nav-item class="px-2" href="https://discord.gg/S2ZkBTnd8X">
          <i class="fab fa-discord mr-1"></i>Discord
        </b-nav-item>
        <b-nav-item class="px-2" to="/status">
          <i class="fas fa-heartbeat mr-1"></i>Status
        </b-nav-item>
        <b-nav-item class="px-2" to="/gaming/deals">
            <i class="fas fa-gamepad"></i> Games
        </b-nav-item>
        <b-nav-item class="px-2" href="/get-premium" >
          <img :src="imageUrl" style="width: 20px; height: auto; margin-bottom: 3px"/> <span style="color:#f8cb00 !important;"> Premium <span />
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="d-lg-none nav-title nav-icons">
        <b-nav-item to="/">
          <i class="fas fa-home"></i>
        </b-nav-item>
        <b-nav-item href="https://docs.carl.gg/">
          <i class="fas fa-book"></i>
        </b-nav-item>
        <b-nav-item
          href="https://discord.com/oauth2/authorize?&client_id=235148962103951360&scope=applications.commands+bot&permissions=2088234230&response_type=code&redirect_uri=https://carl.gg/api/server_auth"
          exact
        >
          <i class="fas fa-plus"></i>
        </b-nav-item>
        <b-nav-item href="https://discord.gg/S2ZkBTnd8X" class="d-sm-down-none">
          <i class="fab fa-discord"></i>
        </b-nav-item>
        <b-nav-item to="/status">
          <i class="fas fa-heartbeat"></i>
        </b-nav-item>
        <b-nav-item to="/gaming/deals">
            <i class="fas fa-gamepad"></i>
        </b-nav-item>
        <b-nav-item href="/get-premium">
          <img :src="imageUrl" style="width: 20px; height: auto; margin-bottom: 3px"/>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <div v-if="logged_in">
          <DefaultHeaderDropdownAccnt />
        </div>
        <div v-else class="mr-auto">
          <b-button
            style="
              background-color: #3a4149;
              border-color: #eee;
              border-width: 2px;
            "
            v-on:click="login"
            class="px-3 btn-pill dark"
            >Login</b-button
          >
        </div>
      </b-navbar-nav>
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body background">
      <main class="main" style="margin-left: 0px">
        <div>
          <br />
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { Header as AppHeader } from "@coreui/vue";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";

export default {
  name: "DefaultContainer",
  components: {
    AppHeader,
    DefaultHeaderDropdownAccnt
  },
  data() {
    return {
      discord_user: {},
      imageUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACtUlEQVR4nO1YS2sTURg9WnQjig9EETe+cJ0qqAt3rdKAIi58gcUudKELf4HiRpe+8A/UZRApSN0Iumht5vuSqAtBBVG6EJWmZO6dVoNor9whr2beqWYmOgcOhJm55zvnm/tgAqRIkSJFiqRCKSzXRC9CMo5LxqxklPVv9BIqBrZJwpxkKE3B+GaWsBO9AKWwTBCe1M03QhCe6XtIOiTjQrv5Bgnn/05RA8ck46MgvBEFZDvVmS9hiySYPgEq+plO9UUBWe3R9so4al9UOfRp4ZZXvSAI1/X1yAUIY57mm/pjUXVVDn2CcEN7a9GatXe42s2qoxDjqZXHprBFLMKJIPN16mfD6s4RNmsvLo2oNrZoSTBcu8X4ajEGgooIwgbB+BI2gCDMyBfYGKQrDRwUhE8eOvnmg4w7nsUYPwXhmt+BJAn3w5pv4ajvTsa4LAg/fNbT7cYAk3AmRMFH5hTWO7rPGOrAfL05R9r1ygbWCMKDoLGmgdPNAEXsCFWUMC2K2Fcf9/kVVknGh04DSML0zCRW1/UqjIwkvA8z1mRsX/zK9LwMN3+r+vXa3Sfc69h8k3dtLQPD+sQOOabsOBQlYTxi9x4Lwq+lBhBaI3rtcedCZFz9A93sDglXHAFMwuHYjXE4mgYOOQJUXmJt20mXSArCgjmBda77r2S864Hp89bV/BIOpG5z1DOAxbiUAIMqgBc9A5iEvQkwqPxoGtjjGUAVsSLCYdJ1CsZ39RorPQPUFvJU3EalFwnPfc3XFvKtBAe4GRjAYpyK3Si702KcDAxwYOhsqX9wRCWR+7PDhcAAmYGRybiN9nswM3huIjCAvQ4SMF2kC0OZ/1cCyLjNynYSzNABBONh7IZ5MfV3cpQAu2v/LKuEcFbksQtRMG9gq2DkJEPEaFzozkc2nyJFihQp/hv8Bs9/K/wQGZy+AAAAAElFTkSuQmCC',
    };
  },
  methods: {
    login() {
      window.location.href = window.location.origin + "/api/login";
    },
    updateAuthInfo(e) {
      if (e.data.discriminator != undefined) {
        this.$store.commit("login", e.data);
      }
      window.removeEventListener("message", this.updateAuthInfo);

      this.$router.push("/servers");
    }
  },
  computed: {
    name() {
      return this.$route.name;
    },
    isGameHeadingEnabled() {
      const viewerCountryCode =
        this.$store.state.user_geo &&
        this.$store.state.user_geo.viewerCountryCode;
      return viewerCountryCode === "US";
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    logged_in() {
      return Object.keys(this.$store.state.discord_user).length !== 0;
    }
  }
};
</script>

<style>
@media screen and (min-width: 1280px) {
  .background {
    background-image: url("~@/../public/img/bgheader.png");
    min-height: 85vh !important;
    background-origin: padding-box;
    background-position: 0% 0%;
    background-repeat: no-repeat;
    background-size: contain !important;
  }
}

@media screen and (min-width: 780px) and (max-width: 1280px) {
  .background {
    background-image: url("~@/../public/img/bgheader-mid.png");
    min-height: 85vh !important;
    background-origin: padding-box;
    background-position: 0% 0%;
    background-repeat: no-repeat;
    background-size: contain !important;
  }
}
@media screen and (max-width: 780px) {
  .background {
    background-image: url("~@/../public/img/bgheader.png");
    min-height: 85vh !important;
    background-origin: padding-box;
    background-position: 0% 0%;
    background-repeat: no-repeat;
  }
  .main::before {
    display: none;
  }
}
</style>

<style scoped>
.nav-title .nav-link {
  font-family: "roboto";
  color: #fff;
}
.nav-icons i {
  font-size: 1.075rem;
}
</style>
